export default __webpack_public_path__ + "static/media/sb1.1c45b846.png";